import fetch from '@/common/js/http';

const customer = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getCustomerWithPage({commit}, params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'customer/page',
                    method: 'get',
                    params:params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createCustomer({commit}, customer) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'customer',
                    method: 'put',
                    data: customer
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveCustomer({cmmmit}, customer) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'customer',
                    method: 'post',
                    data: customer
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getAllCustomer({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'customer/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        }

    }
}
export default customer



// WEBPACK FOOTER //
// ./src/vuex/modules/customer.js